import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";
import { money } from "@/lib/format";

const fmt = (s) => (s ? new Date(`${s}T12:00:00`).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" }) : "");

// Printable gift card: only #gift-print is visible when printing.
export const PrintableGiftCard = ({ card }) => {
  const link = `${window.location.origin}/gift-card-balance?code=${card.code}`;
  return (
    <div className="mt-6" data-testid="printable-gift-card">
      <style>{`@media print {
        body * { visibility: hidden !important; }
        #gift-print, #gift-print * { visibility: visible !important; }
        #gift-print { position: absolute; top: 0; left: 0; width: 100%; box-shadow: none !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }`}</style>
      <div id="gift-print" className="rounded-2xl border-2 border-[#D98E73] bg-[#F9F7F3] p-6 sm:p-8">
        <div className="flex items-start gap-4">
          <div className="flex-1 min-w-0">
            <p className="eyw-label text-[#D98E73]">Enhancing Your World</p>
            <h2 className="font-serif text-2xl sm:text-3xl text-[#144F75] mt-1">Gift Card</h2>
            {card.recipient_name && <p className="text-[#1A242B] mt-3" data-testid="print-recipient">For <b>{card.recipient_name}</b></p>}
          </div>
          <QRCodeSVG value={link} size={88} className="shrink-0" data-testid="print-qr" />
        </div>
        {card.message && <p className="italic text-[#4A5D6B] mt-4 border-l-2 border-[#D98E73] pl-3" data-testid="print-message">“{card.message}”</p>}
        <p className="font-mono text-lg sm:text-xl tracking-widest text-center bg-white rounded-xl py-3 mt-5 break-all" data-testid="print-code">{card.code}</p>
        <div className="flex flex-wrap justify-between gap-2 mt-4 text-sm text-[#1A242B]">
          <span data-testid="print-balance">Balance: <b>{money(card.balance)}</b></span>
          <span data-testid="print-expiry">{card.expires_at ? `Valid until ${fmt(card.expires_at)}` : "No expiry date"}</span>
        </div>
        <p className="text-xs text-[#8FA89B] mt-4">Redeem at enhancingyourworld.com or any front desk. Scan to check the balance.</p>
      </div>
      <button type="button" onClick={() => window.print()} className="eyw-btn mt-4 print:hidden" data-testid="print-gift-card-btn"><Printer size={16} /> Print gift card</button>
    </div>
  );
};
